import { connect } from "react-redux";
import { UsersComponent } from "./UsersComponent";
import React, { Component } from "react";
import * as usersActionCreators from "../actions";
import { setWarningMessage } from "../../messages/actions";
import { translate } from "react-i18next";
import { bindActionCreators } from "redux";
import { getCleaners, isAdmin } from "../selectors";

class UsersContainer extends Component {
  constructor() {
    super();
    this.state = { modalVisible: false, selected: undefined };
  }
  componentWillMount() {
    if (this.props.users.length === 0) {
      this.props.getUsers();
    }
  }

  toggleModal = user => {
    this.setState(prevState => ({
      modalVisible: !prevState.modalVisible,
      selected: user
    }));
  };

  onSubmit = user => {
    if (!user.email) {
      this.props.setWarningMessage("Email can't be empty");
      return;
    }
    if (!user.firstname) {
      this.props.setWarningMessage("First name can't be empty");
      return;
    }
    if (!user.surname) {
      this.props.setWarningMessage("Surname can't be empty");
      return;
    }
    if (!user.userId && !user.password) {
      this.props.setWarningMessage("Password can't be empty");
      return;
    }

    if (!user.hotelIds || user.hotelIds.length === 0) {
      this.props.setWarningMessage("You have to select at least one hotel");
      return;
    }
    if (user.userId) {
      this.props.updateUser(user);
    } else {
      this.props.createUser(user);
    }
    this.toggleModal();
  };
  render() {
    return (
      <UsersComponent
        {...this.props}
        {...this.state}
        onSubmit={this.onSubmit}
        toggleModal={this.toggleModal}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    users: getCleaners(state),
    phase: state.users.phase,
    isAdmin: isAdmin(state),
    hotels: state.hotels.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      { ...usersActionCreators, setWarningMessage },
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(UsersContainer));



// WEBPACK FOOTER //
// ./src/users/UsersList/index.js